import { Component, OnInit, ViewChild, HostListener, DEFAULT_CURRENCY_CODE, Inject, TemplateRef } from '@angular/core';
import { CDSMask } from '@app/utils/cds-mask';
import { Router } from '@angular/router';
import { ImportacaoPublicacaoService } from '@app/services/importar-publicacao.service';
import { ProcessoMovimentacao, TipoMovimentacao } from '@app/models/processo-movimentacao';
import { MeAvise } from '@app/models/me-avise';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, from, Observable, throwError } from 'rxjs';

import { ProcessoConsulta } from '@app/models/processo.model';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { PublicacaoManual } from './publicacao.model';
import { UsuarioService } from '@app/services/usuario.service';
import { UploadFile } from '@app/components/upload-file/upload-file';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { ProcessoService } from '@app/services/processo.service';
import { BlobServiceClient, BlockBlobUploadOptions, ContainerClient } from '@azure/storage-blob';
import { switchMap } from 'rxjs/operators';
import { Publicacao } from '@app/models/publicacao';
import { Area } from '@app/models/area';
import { AreaService } from '@app/services/area.service';
import { error, log } from 'console';
import { errorObject } from 'rxjs/internal-compatibility';
import debounce from '@app/utils/debounce';
import { BuscarProcessosModel } from '../buscar-processos/model';


@Component({
  selector: 'app-importacao-publicacao',
  templateUrl: './importacao-publicacao.component.html',
  styleUrls: ['./importacao-publicacao.scss']
})
export class ImportacaoPublicacaoComponent implements OnInit {

  cdsMask = new CDSMask();
  lstErros: string[];

  @ViewChild('publicacaoManualModal', { static: true })

  publicacaoManualModal: TemplateRef<any>;
  publicacao: Publicacao = new Publicacao();
  publicacaoManual: PublicacaoManual = new PublicacaoManual();
  processoMovimentacao: ProcessoMovimentacao = new ProcessoMovimentacao();

  lstProcessoMovimentacao: ProcessoMovimentacao[];
  tipoMovSelecionada: TipoMovimentacao;

  bsModalRef: BsModalRef;
  modalRefNovaPublicacaoManual: BsModalRef;

  public areaIdPublicacao: number;
  public descricaoAreaPublicacao: string;
  public listaArea: IdDescricao[] = [];
  public titulo: string;
  public tipoArquivo = 'xml';

  public descricao = '';
  public carregandoPublicacoes = false;
  public gravando = false;

  lstProcesso: ProcessoConsulta[] = [];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao = '';

  caminho: string = '/mov/judicial';

  @ViewChild('fileInput', { static: true }) fileInput;
  bloqueiaBotaoImportar = true;

  lstUsuarios: IdDescricao[];

  // flagPassadoParaNome = false;
  nomePassadoParaMeavise = '#nome_me_avise#';
  nomePassadoParaPrazo= '#nome_prazo#'
  buscarProcessosModel: BuscarProcessosModel = new BuscarProcessosModel();
  lstProcessoEncerrados: ProcessoConsulta[] = [];
  lstProcessoAtivos: ProcessoConsulta[] = [];

  @HostListener('document:keydown', ['$event'])
  atalhoGravar(event: KeyboardEvent) {
    if (event.which === 83 && event.ctrlKey) {
      event.preventDefault();
      if (confirm('deseja realmente gravar?')) {
        this.adicionar(this.publicacao.Id);
      }
    }
  }

  constructor(
    private router: Router,
    private consultasService: ConsultasService,
    private importacaoPublicacaoService: ImportacaoPublicacaoService,
    private modalService: BsModalService,
    @Inject(ToastrService) public toastr: ToastrService,
    private usuarioService: UsuarioService,
    private processoService: ProcessoService,
    private areaService: AreaService
  ) { }

  ngOnInit() {
    this.consultasService.consultar("AREA", '').toPromise()
    .then((data : IdDescricao[]) => {
          this.listaArea = data;
          if(this.listaArea.length > 0){
            let areaPadrao = this.listaArea[0];
            this.alterarAreaPublicacao(areaPadrao.Id, areaPadrao.Descricao);
            this.obterTodosProcessos(this.filtroDescricao, 1);
          }
        },
        (erro) => {
          console.error('Erro ao obter a lista de áreas:', erro);
        }
    );

    this.router.events.subscribe(() => window.scrollTo(0, 0));

    this.lstProcesso = [];
    this.consultasService.consultar('USUARIO_APELIDO').toPromise().then(data => {
      this.lstUsuarios = data
    });

    this.usuarioService.obterUsuarioLogado().toPromise().then(usuarioLogado => {
      this.publicacaoManual.UsuarioId = usuarioLogado;
    });

  }

  recebeNomeAdvogado(nome: any) {
    let nomeFantasia = '';
    if (nome.target.value > 0) {
      nomeFantasia = this.lstUsuarios.find(element => String(element.Id) === String(nome.target.value)).Descricao;
    }
    // if (nomeFantasia !== '' && this.flagPassadoParaNome) {
    if (nomeFantasia !== '') {
      if (this.processoMovimentacao.Descricao.indexOf('#nome_me_avise#') > -1) {
        this.processoMovimentacao.Descricao = this.processoMovimentacao.Descricao.replace('#nome_me_avise#', nomeFantasia);
      } else {
        this.processoMovimentacao.Descricao = this.processoMovimentacao.Descricao.replace(`Passado para ${this.nomePassadoParaMeavise}`, `Passado para ${nomeFantasia}`);
      }
      this.nomePassadoParaMeavise = nomeFantasia;
    }
  }
  recebeNomePrazo(nome: any) {
    let nomeFantasia = '';
    if (nome.target.value > 0) {
      nomeFantasia = this.lstUsuarios.find(element => String(element.Id) === String(nome.target.value)).Descricao;
    }
    // if (nomeFantasia !== '' && this.flagPassadoParaNome) {
    if (nomeFantasia !== '') {
      if (this.processoMovimentacao.Descricao.indexOf('#nome_prazo#') > -1) {
        this.processoMovimentacao.Descricao = this.processoMovimentacao.Descricao.replace('#nome_prazo#', nomeFantasia);
      } else {
        this.processoMovimentacao.Descricao = this.processoMovimentacao.Descricao.replace(`Passado para ${this.nomePassadoParaPrazo}`, `Passado para ${nomeFantasia}`);
      }
      this.nomePassadoParaPrazo = nomeFantasia;
    }
  }

  private novaMovimentacao() {
    this.processoMovimentacao = new ProcessoMovimentacao();
    // this.processoMovimentacao.AtoProcessualId = null;
    this.processoMovimentacao.TipoMovimentacaoId = 3;
    this.processoMovimentacao.MeAvise.push(new MeAvise(this.preecheDataMovimentacao()));
    this.processoMovimentacao.Prazo.push(new MeAvise(this.preecheDataMovimentacao()));

    let clienteNome = '';
    let parteContraria = '';

    if (this.publicacao.Processo) {
      clienteNome = this.publicacao.Processo.ClienteNome;
      parteContraria = this.publicacao.Processo.ParteContraria;

      this.tipoMovSelecionada = TipoMovimentacao.JUDICIAL;
    }

    const aud = new MinhaAgenda(clienteNome + ' (' + this.publicacao.Processo?.Ficha + ')' + ' x ' + parteContraria);
    aud.UsuarioId = 0;
    this.processoMovimentacao.Audiencia.push(aud);
  }

  confereExtensaoArquivo() {
    var arquivos = this.fileInput ? this.fileInput.nativeElement.files : [];

    var partesNomeArquivo = arquivos[0].name.split('.');
    var extensaoArquivo = partesNomeArquivo[partesNomeArquivo.length - 1] === "xlsx" ? "excel" : "xml";

    if (extensaoArquivo !== this.tipoArquivo) {
      this.toastr.warning(
        "O arquivo é do formato: " + (extensaoArquivo === "excel" ? "XLSX" : "XML"),
        "Formato esperado: " + (this.tipoArquivo === "excel" ? "XLSX" : "XML")
      );
      this.bloqueiaBotaoImportar = true;
    }

    if (extensaoArquivo === this.tipoArquivo) {
      this.bloqueiaBotaoImportar = false;
    }
  }

  enviarPublicacao() {
    const fi = this.fileInput.nativeElement;
    if(!fi.files || !fi.files[0]){
      this.toastr.error("Nenhum arquivo selecionado");
      this.bloqueiaBotaoImportar = true;
      return;
    }
    
    const fileToUpload = fi.files[0];
    const file = new FormData();
    file.append('file', fileToUpload);
    file.append('areaId', this.areaIdPublicacao.toString());

    if(fileToUpload.name.includes(".xml")){
      this.enviarPublicacaoXml(file);
      return;
    }

    if(fileToUpload.name.includes(".xlsx")){
      this.enviarPublicacaoExcel(file)
      return;
    }
  }

  enviarPublicacaoXml(file){
      this.importacaoPublicacaoService.enviarPublicacaoXml(file).subscribe(
        data => {
          this.fileInput.nativeElement.value = '';
          this.obterTodos(0);
  
          if(data === 'sucesso'){
            this.toastr.success('Sucesso ao importar as publicações', 'Notificação!');
          }else{
            this.toastr.error('Arquivo inválido', 'Notificação!');
          }
  
          this.bloqueiaBotaoImportar = true;
        }
      );
  }

  enviarPublicacaoExcel(file){

    this.importacaoPublicacaoService.enviarPublicacaoExcel(file)
    .subscribe(
      sucesso =>
        { 
        this.fileInput.nativeElement.value = ''
        this.obterTodos(0);
        this.toastr.success('Sucesso ao importar as publicações', 'Notificação!')
      }, 
      data => {
        this.fileInput.nativeElement.value = ''
        this.toastr.error(data.error.errors[0])
      }
    );
  }
  

  salvarPublicacaoManual() {
     this.importacaoPublicacaoService.enviarPublicacaoManual(this.publicacaoManual).toPromise().then(
      () => {
        this.fecharModalInfo();
        if('sucesso'){
        return this.toastr.success('Sucesso ao adicionar nova publicação'),this.fecharModalInfo();
        }
        else
        {
          return this.toastr.error('Erro ao adcionar a publicação'),
          this.fecharModalInfo();
        }
      });
  }

  obterTodos(processoId: number) {
    this.nomePassadoParaMeavise = '#nome_me_avise#';
    this.nomePassadoParaPrazo= '#nome_prazo#'
    if (processoId === 0) {
      this.carregandoPublicacoes = true;
      this.publicacao = new Publicacao();
    }
    this.importacaoPublicacaoService.obterPublicacoes(this.areaIdPublicacao, processoId).toPromise()
      .then(data => {
        this.publicacao = data;
        this.carregandoPublicacoes = false;
        this.preecheDataMovimentacao();
        this.novaMovimentacao();
        this.lstErros = [];

      });
  }

  public alterarAreaPublicacao(areaId: number, descricao: string) {
    this.areaIdPublicacao = areaId;
    this.descricaoAreaPublicacao = descricao;
    this.publicacaoManual.AreaId = this.areaIdPublicacao;
    this.titulo = this.transformarEmTitulo(descricao);

    if(this.descricaoAreaPublicacao == 'PREVCIV'){
      this.titulo = 'Prev. e Cível';
    }

    this.obterTodos(0);
  }

  private transformarEmTitulo(frase: string): string {
    var titulo = frase.toLowerCase().replace(/(?:^|\s)\S/g, (letra) => letra.toLocaleUpperCase());
    return titulo;
  }

  public atalho(texto: string, isDate: boolean = false) {
    if (isDate) {
      texto = texto.replace(/(\d{4})\-(\d{2})\-(\d{2})/g, '$3/$2/$1');
    }


    this.processoMovimentacao.Descricao += texto + ' ';
    // this.flagPassadoParaNome = texto == 'Passado para #nome#';
  }


  adicionar(publicacaoIdParaRemover: number) {
    this.processoMovimentacao.ProcessoId = this.publicacao.Processo.Id;
    this.processoMovimentacao.NumeroInstancia = this.publicacao.NProcesso;
    this.processoMovimentacao.PublicacaoId = publicacaoIdParaRemover;
    this.enviarParaSalvarNovaMovimentacao(publicacaoIdParaRemover);
    // if (this.processoMovimentacao.Descricao != "") {
    //   window.open("#/processos/processo/" + this.publicacao.Processo.Id + this.caminho, '_blank');
    // }

  }
  remover(publicacaoId: number, nProcesso: string) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir a publicação? ' + nProcesso;
    this.bsModalRef.content.confirmar = () => {
      this.funcaoRemover(publicacaoId);
    };
  }

  funcaoRemover(publicacaoId: number) {
    this.importacaoPublicacaoService.removerPublicacao(publicacaoId).toPromise().then(
      () => {
        this.obterTodos(0);
      });
  }
 
  debounce(func: (...args: any[]) => void, wait: number) {
    let timeout: ReturnType<typeof setTimeout>;
    return function(...args: any[]) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  onKeyPress = debounce((event: KeyboardEvent) => {
    this.buscarProcessosModel.FiltroDescricao = this.filtroDescricao;
    if (this.buscarProcessosModel.FiltroDescricao.length >= 3 || this.buscarProcessosModel.FiltroDescricao.length == 0) {
      this.obterTodosProcessos(this.filtroDescricao, 1);
      }
    this.paginacao.paginaAtual = 1;
  }, 300);
  

obterTodosProcessos(descricao: string, pagina: number) {
  this.buscarProcessosModel.FiltroDescricao = descricao;
  this.buscarProcessosModel.Pagina = pagina;

   this.importacaoPublicacaoService.buscaProcesso(this.buscarProcessosModel).subscribe(
    data => {
      // Junta todos os processos em uma lista só
      this.lstProcesso = data.Dados || [];
      this.paginacao.totalDeItens = data.Total;
    },
    erro => {
      this.toastr.warning('Realize a pesquisa novamente.');
    }
  );
}

  public pageChanged(event: any): void {
    this.obterTodosProcessos(this.filtroDescricao, event.page);
  }

  public trocaCaminho() {

    if (this.processoMovimentacao.TipoMovimentacaoId.toString() === '1') {
      this.caminho = '/mov/administrativa';
    } else if (this.processoMovimentacao.TipoMovimentacaoId.toString() === '2') {
      this.caminho = '/mov/execucao-provisoria';
    } else if (this.processoMovimentacao.TipoMovimentacaoId.toString() === '3') {
      this.caminho = '/mov/judicial';
    }
  }

  vincularProcesso(idProcesso: number) {
    this.importacaoPublicacaoService.vincularProcesso(this.publicacao.Id, idProcesso)
      .subscribe(data => {
        const processo = data;
        if (processo != null) {
          this.publicacao.Processo = processo;
          this.tipoMovSelecionada = TipoMovimentacao.JUDICIAL;
          const clienteNome = this.publicacao.Processo.ClienteNome;
          const parteContraria = this.publicacao.Processo.ParteContraria;
          this.processoMovimentacao.Audiencia.forEach(element => {
            element.Descricao = clienteNome + ' (' + this.publicacao.Processo.Ficha + ')' + ' x ' + parteContraria;
          });
        }

        this.bsModalRef.hide();
        this.lstProcesso = [];
        this.filtroDescricao = ''
        this.paginacao.totalDeItens = 0;
      });
  }

  open(content) {
    this.bsModalRef = this.modalService.show(content, { class: 'modal-lg' });
  }

  alterarDataMeAvise() {
    if (this.descricaoAreaPublicacao !== '' && this.descricaoAreaPublicacao.toUpperCase() === 'TRABALHISTA') {
      this.processoMovimentacao.MeAvise.forEach(element => {
        element.Data = this.processoMovimentacao.Data;
      });
      this.processoMovimentacao.Prazo.forEach(element => {
        element.Data = this.processoMovimentacao.Data;
      });
    }
  }

  enviarParaSalvarNovaMovimentacao(publicacaoId: number) {
    document.getElementById('overlay').style.display = 'block';
    this.gravando = true;
    let contadorSucesso: number = 0;
    this.importacaoPublicacaoService.adicionarMovimentacao(this.processoMovimentacao).subscribe(
      async (data) => {

        const observables: Observable<any>[] = [];
        if (this.processoMovimentacao.Arquivos.length > 0) {
          observables.push(from(this.importacaoPublicacaoService.gerarPdf(publicacaoId, this.processoMovimentacao.ProcessoId, data).toPromise()));

          for (let j = 0; j < this.processoMovimentacao.Arquivos.length; j++) {

            if(this.processoMovimentacao.Arquivos[j].File.size > 20971520){
              this.toastr.error( this.processoMovimentacao.Arquivos[j].File.name, 'Tamanho de Arquivo superior a 20 MB');
              this.gravando = false;
              document.getElementById('overlay').style.display = 'none';
              continue;
            }

            let processoAnexo: ProcessoAnexo = this.AdicionarInformacoesProcessoAnexo(this.processoMovimentacao.Arquivos[j], this.processoMovimentacao.ProcessoId, data);

            observables.push(from(this.AdicionarAnexoDiretamenteNoStorage(processoAnexo, this.processoMovimentacao.Arquivos[j])));
          }

          forkJoin(observables).subscribe(() => {
            this.router.navigate(['./processos/processo/' + this.publicacao.Processo.Id + this.caminho]);
            this.novaMovimentacao();
            this.toastr.success('Sucesso ao adicionar nova movimentação', 'Notificação!');
            window.scrollTo(0, 0);
            this.gravando = false;
            this.obterTodos(0);
            document.getElementById('overlay').style.display = 'none';
          });
        }
        else{
          this.importacaoPublicacaoService.gerarPdf(publicacaoId, this.processoMovimentacao.ProcessoId, data).toPromise().then(() => {
            if (this.processoMovimentacao.Descricao !== '') {
              this.router.navigate(['./processos/processo/' + this.publicacao.Processo.Id + this.caminho]);
              document.getElementById('overlay').style.display = 'none';
            }
            this.novaMovimentacao();
            this.toastr.success('Sucesso ao adicionar nova movimentação', 'Notificação!');
            window.scrollTo(0, 0);
            this.gravando = false;
            this.obterTodos(0);
          });
        }
      },
      (retornoErro: any) => {
        this.gravando = false;
        if (retornoErro.error) {
          this.lstErros = retornoErro.error.errors;
        }
        document.getElementById('overlay').style.display = 'none';
      });
  }

  preecheDataMovimentacao() {
    if (this.publicacao !== null && this.publicacao.DataPublicacao !== null) {
      this.processoMovimentacao.Data = new Date(this.publicacao.DataPublicacao).toISOString().split('T')[0];
      return this.processoMovimentacao.Data;
    }
    return '';
  }

  retornaTipoMovimentacao(tipo: number) {
    if (tipo.toString() === '1') {
      return 'Administrativa';
    }
    if (tipo.toString() === '2') {
      return 'Execução Provisória';
    }
    if (tipo.toString() === '3') {
      return 'Judicial';
    }
  }

  abrirPublicacaoManual() {
    this.modalService.show(this.publicacaoManualModal);
  }

  fecharModalInfo() {
    this.modalService.hide();
    this.publicacaoManual = new PublicacaoManual();
  }

  AdicionarAnexoDiretamenteNoStorage(processoAnexo: ProcessoAnexo, fileProcessoAnexo: UploadFile): Promise<void>{
    let idAnexoMovimentacao: number = 0;

    return this.processoService.movimentacaoGravarProcessoAnexoRetornandoSas(processoAnexo).pipe(
      switchMap(uploadFileSasUrl => {
        fileProcessoAnexo.progress = 0;

        idAnexoMovimentacao = Number.parseInt(uploadFileSasUrl.NomeArquivo.replace(/([A-z]+)\_(\d+)\.([A-z0-9]+)/, "$2"), 10);

        let blobService: BlobServiceClient = new BlobServiceClient(
          uploadFileSasUrl.SasUrlUpload
        );

        let containerClient: ContainerClient = blobService.getContainerClient('');

        const blobClient = containerClient.getBlockBlobClient(uploadFileSasUrl.NomeArquivo);

        fileProcessoAnexo.progress = 10;

        let optionsBlobClient: BlockBlobUploadOptions = {
          onProgress: (ev) => { fileProcessoAnexo.progress = Math.round((ev.loadedBytes / fileProcessoAnexo.File.size) * 80) + 10; },
          blobHTTPHeaders: { blobContentType: fileProcessoAnexo.File.type }
        };

        let observableUploadArquivoDiretamentoNoStorage = from(blobClient.upload(fileProcessoAnexo.File, fileProcessoAnexo.File.size, optionsBlobClient));

        return observableUploadArquivoDiretamentoNoStorage;
      })
    ).pipe(
      switchMap(retornoObservableUploadArquivoDiretamentoNoStorage => {
        let observableConferindoExistenciaArquivoNoStorage = this.processoService.verificaExistenciaArquivoMovimentacao(idAnexoMovimentacao, "proanexo").toPromise().then((existenciaArquivo) => {
          if (existenciaArquivo) {
            fileProcessoAnexo.progress = 100;
          }
          else {
            this.processoService.movimentacaoDeletarArquivo(idAnexoMovimentacao);
          }}).catch(error => {
            this.lstErros.push("não foi possível realizar o upload !");
            this.processoService.movimentacaoDeletarArquivo(idAnexoMovimentacao);
          });
          return observableConferindoExistenciaArquivoNoStorage;
      })
    ).toPromise().catch(error => {
      // Adicionar após resolver erro 403 do storage.
      // this.processoService.movimentacaoDeletarArquivo(idAnexoMovimentacao);
      // this.lstErros.push("não foi possível realizar o upload !");
      // this.gravando = false;
    });
  }

  AdicionarInformacoesProcessoAnexo(fileProcessoAnexo: UploadFile, processoId: number, movimentacaoId: number) {
    let processoAnexo = new ProcessoAnexo();
    let fileNameArray: string[] = fileProcessoAnexo.File.name.split('.');

    processoAnexo.ArquivoNome = fileProcessoAnexo.File.name;
    processoAnexo.Descricao = fileProcessoAnexo.Descricao;
    processoAnexo.Extensao = fileNameArray[fileNameArray.length - 1];

    processoAnexo.MovimentacaoId = movimentacaoId;
    processoAnexo.ProcessoId = processoId;
    return processoAnexo;
  }
}
